/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class DncApiServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * CheckBackFile
     * @param path path
     * @return OK
     */
    checkBackFile(path: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/check-file-exist?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckBackFile(_response);
        });
    }

    protected processCheckBackFile(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * cnc删除文件
     * @param appCode appCode
     * @param fileName fileName
     * @param gatewayCode gatewayCode
     * @return OK
     */
    delCncFile(appCode: number, fileName: string, gatewayCode: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/cnc-delete-file?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelCncFile(_response);
        });
    }

    protected processDelCncFile(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * cnc读取文件
     * @param appCode appCode
     * @param fileName fileName
     * @param gatewayCode gatewayCode
     * @return OK
     */
    readCncFile(appCode: number, fileName: string, gatewayCode: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/cnc-read-file?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReadCncFile(_response);
        });
    }

    protected processReadCncFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * cnc获取文件列表
     * @param appCode appCode
     * @param gatewayCode gatewayCode
     * @return OK
     */
    readCncFileList(appCode: number, gatewayCode: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/cnc-read-file-list?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReadCncFileList(_response);
        });
    }

    protected processReadCncFileList(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * cnc修改文件名称
     * @param updateFileNameDTO updateFileNameDTO
     * @return OK
     */
    updateCncFileName(updateFileNameDTO: CncUpdateFileNameDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/cnc-rename-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFileNameDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCncFileName(_response);
        });
    }

    protected processUpdateCncFileName(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * cnc文件上传
     * @param cncWriteFileDTO cncWriteFileDTO
     * @return OK
     */
    uploadCncFile(cncWriteFileDTO: CncWriteFileDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/cnc-upload-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cncWriteFileDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadCncFile(_response);
        });
    }

    protected processUploadCncFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * readDirectory
     * @param path path
     * @return OK
     */
    readDirectory(path: string): Promise<DirectoryDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/directory/read?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReadDirectory(_response);
        });
    }

    protected processReadDirectory(response: AxiosResponse): Promise<DirectoryDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DirectoryDto.fromJS(resultData200) : new DirectoryDto();
            return result200;
        }
        return Promise.resolve<DirectoryDto>(<any>null);
    }

    /**
     * entriesExists
     * @param path path
     * @param type type
     * @return OK
     * @deprecated
     */
    entriesExists(path: string, type: number): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/entries/exists?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEntriesExists(_response);
        });
    }

    protected processEntriesExists(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * entriesInfo
     * @param path path
     * @return OK
     */
    entriesInfo(path: string): Promise<EntiryInfoDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/entries/info?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEntriesInfo(_response);
        });
    }

    protected processEntriesInfo(response: AxiosResponse): Promise<EntiryInfoDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? EntiryInfoDto.fromJS(resultData200) : new EntiryInfoDto();
            return result200;
        }
        return Promise.resolve<EntiryInfoDto>(<any>null);
    }

    /**
     * readFile
     * @param length length
     * @param offset offset
     * @param path path
     * @return OK
     * @deprecated
     */
    readFile(length: string, offset: string, path: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/file/read?";
        if (length === undefined || length === null)
            throw new Error("The parameter 'length' must be defined and cannot be null.");
        else
            url_ += "length=" + encodeURIComponent("" + length) + "&"; 
        if (offset === undefined || offset === null)
            throw new Error("The parameter 'offset' must be defined and cannot be null.");
        else
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReadFile(_response);
        });
    }

    protected processReadFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * SaveBackFile
     * @param ossFile ossFile
     * @param path path
     * @return OK
     */
    saveBackFile(ossFile: OssFile, path: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/save-back-file?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ossFile);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveBackFile(_response);
        });
    }

    protected processSaveBackFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * getTransferDirectoryFileByPath
     * @param path path
     * @return OK
     */
    getTransferDirectoryFileByPath(path: string): Promise<TransferDirectoryFile> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-dir/file?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTransferDirectoryFileByPath(_response);
        });
    }

    protected processGetTransferDirectoryFileByPath(response: AxiosResponse): Promise<TransferDirectoryFile> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TransferDirectoryFile.fromJS(resultData200) : new TransferDirectoryFile();
            return result200;
        }
        return Promise.resolve<TransferDirectoryFile>(<any>null);
    }

    /**
     * uploadFromFtp
     * @param offset (optional) offset
     * @param path path
     * @param sha256 (optional) sha256
     * @return OK
     * @deprecated
     */
    uploadFromFtp(offset: number | null | undefined, path: string, sha256: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/upload-from-ftp?";
        if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&"; 
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        if (sha256 !== undefined)
            url_ += "sha256=" + encodeURIComponent("" + sha256) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadFromFtp(_response);
        });
    }

    protected processUploadFromFtp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class FileServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除文件
     * @param deleteFileDto deleteFileDto
     * @return OK
     */
    delete(deleteFileDto: DeleteFileDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteFileDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 批量保存文件
     * @param list list
     * @return OK
     */
    batchSave(list: UploadFileOssDto[]): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/batch-save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBatchSave(_response);
        });
    }

    protected processBatchSave(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 复制文件接口
     * @param changeFileParentDto changeFileParentDto
     * @return OK
     */
    copy(changeFileParentDto: ChangeFileParentDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/copy_to";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeFileParentDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 新建文件接口
     * @param createFileDto createFileDto
     * @return OK
     */
    createFile(createFileDto: CreateFileDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/create-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFileDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateFile(_response);
        });
    }

    protected processCreateFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 移动文件接口
     * @param changeFileParentDto changeFileParentDto
     * @return OK
     */
    move(changeFileParentDto: ChangeFileParentDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/move_to";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeFileParentDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 编辑文件内容接口
     * @param updateFileDto updateFileDto
     * @return OK
     */
    updateFile(updateFileDto: UpdateFileDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/update-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFileDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateFile(_response);
        });
    }

    protected processUpdateFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 保存文件接口
     * @param input input
     * @return OK
     */
    upload(input: UploadFileDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 文件属性
     * @param id id
     * @return OK
     */
    detail(id: string): Promise<FileDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return result200;
        }
        return Promise.resolve<FileDto>(<any>null);
    }

    /**
     * 文件重命名接口
     * @param id id
     * @param renameDto renameDto
     * @return OK
     */
    rename(id: string, renameDto: RenameDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/{id}/rename";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(renameDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRename(_response);
        });
    }

    protected processRename(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 文件版本列表
     * @param id id
     * @return OK
     */
    versionList(id: string): Promise<FileVersionDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/{id}/versions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVersionList(_response);
        });
    }

    protected processVersionList(response: AxiosResponse): Promise<FileVersionDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileVersionDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FileVersionDto[]>(<any>null);
    }

    /**
     * 版本详情接口
     * @param id id
     * @param versionId versionId
     * @return OK
     */
    versionDetail(id: string, versionId: string): Promise<FileVersionDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/{id}/versions/{versionId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVersionDetail(_response);
        });
    }

    protected processVersionDetail(response: AxiosResponse): Promise<FileVersionDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FileVersionDto.fromJS(resultData200) : new FileVersionDto();
            return result200;
        }
        return Promise.resolve<FileVersionDto>(<any>null);
    }

    /**
     * 切换文件版本接口
     * @param id id
     * @param versionId versionId
     * @return OK
     */
    switchVersion(id: string, versionId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/files/{id}/versions/{versionId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSwitchVersion(_response);
        });
    }

    protected processSwitchVersion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class FolderServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * folderList
     * @param parent (optional) parent
     * @param searchKey (optional) searchKey
     * @return OK
     */
    folderList(parent: string | null | undefined, searchKey: string | null | undefined): Promise<FolderListDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/folders?";
        if (parent !== undefined)
            url_ += "parent=" + encodeURIComponent("" + parent) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFolderList(_response);
        });
    }

    protected processFolderList(response: AxiosResponse): Promise<FolderListDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FolderListDto.fromJS(resultData200) : new FolderListDto();
            return result200;
        }
        return Promise.resolve<FolderListDto>(<any>null);
    }

    /**
     * create
     * @param dto dto
     * @return OK
     */
    create(dto: NewFolderDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * folderAllList
     * @return OK
     */
    folderAllList(): Promise<MyFolderListDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/folders/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFolderAllList(_response);
        });
    }

    protected processFolderAllList(response: AxiosResponse): Promise<MyFolderListDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MyFolderListDto.fromJS(resultData200) : new MyFolderListDto();
            return result200;
        }
        return Promise.resolve<MyFolderListDto>(<any>null);
    }

    /**
     * 文件夹列表(懒加载)
     * @param id (optional) 文件夹Id
     * @return OK
     */
    lazyFolderList(id: string | null | undefined): Promise<FolderDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/folders/lazy?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLazyFolderList(_response);
        });
    }

    protected processLazyFolderList(response: AxiosResponse): Promise<FolderDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FolderDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FolderDto[]>(<any>null);
    }
}

export class FormFieldManageServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * findFieldList
     * @param code code
     * @return OK
     */
    findFieldList(code: string): Promise<FormFieldDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/form-field-manage/list?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindFieldList(_response);
        });
    }

    protected processFindFieldList(response: AxiosResponse): Promise<FormFieldDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormFieldDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FormFieldDto[]>(<any>null);
    }

    /**
     * remove
     * @param fieldCode fieldCode
     * @param formCode formCode
     * @return OK
     */
    remove(fieldCode: string, formCode: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/form-field-manage/remove?";
        if (fieldCode === undefined || fieldCode === null)
            throw new Error("The parameter 'fieldCode' must be defined and cannot be null.");
        else
            url_ += "fieldCode=" + encodeURIComponent("" + fieldCode) + "&"; 
        if (formCode === undefined || formCode === null)
            throw new Error("The parameter 'formCode' must be defined and cannot be null.");
        else
            url_ += "formCode=" + encodeURIComponent("" + formCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * create
     * @param code code
     * @param dto dto
     * @return OK
     */
    create(code: string, dto: FormFieldDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/form-field-manage/save?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * update
     * @param code code
     * @param dto dto
     * @return OK
     */
    update(code: string, dto: FormFieldDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/form-field-manage/update?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class FormRenderServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * findFilterSchema
     * @param formCode formCode
     * @return OK
     */
    findFilterSchema(formCode: string): Promise<FilterSchemaDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/form-render/filter-schema?";
        if (formCode === undefined || formCode === null)
            throw new Error("The parameter 'formCode' must be defined and cannot be null.");
        else
            url_ += "formCode=" + encodeURIComponent("" + formCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindFilterSchema(_response);
        });
    }

    protected processFindFilterSchema(response: AxiosResponse): Promise<FilterSchemaDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FilterSchemaDto.fromJS(resultData200) : new FilterSchemaDto();
            return result200;
        }
        return Promise.resolve<FilterSchemaDto>(<any>null);
    }

    /**
     * findFormSchema
     * @param formCode formCode
     * @return OK
     */
    findFormSchema(formCode: string): Promise<FormSchemaDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/form-render/form-schema?";
        if (formCode === undefined || formCode === null)
            throw new Error("The parameter 'formCode' must be defined and cannot be null.");
        else
            url_ += "formCode=" + encodeURIComponent("" + formCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindFormSchema(_response);
        });
    }

    protected processFindFormSchema(response: AxiosResponse): Promise<FormSchemaDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FormSchemaDto.fromJS(resultData200) : new FormSchemaDto();
            return result200;
        }
        return Promise.resolve<FormSchemaDto>(<any>null);
    }

    /**
     * findAllTableColumnList
     * @param formCode formCode
     * @return OK
     */
    findAllTableColumnList(formCode: string): Promise<TableColumnDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/form-render/table-column-list?";
        if (formCode === undefined || formCode === null)
            throw new Error("The parameter 'formCode' must be defined and cannot be null.");
        else
            url_ += "formCode=" + encodeURIComponent("" + formCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindAllTableColumnList(_response);
        });
    }

    protected processFindAllTableColumnList(response: AxiosResponse): Promise<TableColumnDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TableColumnDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TableColumnDto[]>(<any>null);
    }
}

export class ManageDirectoryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 文件管理目录删除
     * @param id (optional) 主键Id
     * @return OK
     */
    delete(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/manage-directory/delete/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 文件管理目录保存
     * @param manageDirectoryDto manageDirectoryDto
     * @return OK
     */
    save(manageDirectoryDto: ManageDirectoryDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/manage-directory/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(manageDirectoryDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取文件管理目录树形结构
     * @param isSetting (optional) isSetting
     * @return OK
     */
    treeList(isSetting: number | null | undefined): Promise<ManageDirectoryTreeDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/manage-directory/treeList?";
        if (isSetting !== undefined)
            url_ += "isSetting=" + encodeURIComponent("" + isSetting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTreeList(_response);
        });
    }

    protected processTreeList(response: AxiosResponse): Promise<ManageDirectoryTreeDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ManageDirectoryTreeDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ManageDirectoryTreeDto[]>(<any>null);
    }

    /**
     * 文件管理目录编辑
     * @param updateDto updateDto
     * @return OK
     */
    update(updateDto: ManageDirectoryDto): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/manage-directory/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ResourceServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * create
     * @param resourceDto resourceDto
     * @return OK
     */
    create(resourceDto: ResourceCreateOrUpdateDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resourceDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * createAndPublish
     * @param resourceDto resourceDto
     * @return OK
     */
    createAndPublish(resourceDto: ResourceCreateOrUpdateDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/create-publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resourceDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateAndPublish(_response);
        });
    }

    protected processCreateAndPublish(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * delete
     * @param id id
     * @return OK
     */
    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * dynamicListPage
     * @param filter filter
     * @param query query
     * @return OK
     */
    dynamicListPage(filter: any, query: string): Promise<IPageOfResourceListDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/dynamic-page-list?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDynamicListPage(_response);
        });
    }

    protected processDynamicListPage(response: AxiosResponse): Promise<IPageOfResourceListDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfResourceListDto.fromJS(resultData200) : new IPageOfResourceListDto();
            return result200;
        }
        return Promise.resolve<IPageOfResourceListDto>(<any>null);
    }

    /**
     * list
     * @param documentDirectoryId documentDirectoryId
     * @param filter filter
     * @return OK
     */
    list(documentDirectoryId: string, filter: any): Promise<ResourceListDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/list?";
        if (documentDirectoryId === undefined || documentDirectoryId === null)
            throw new Error("The parameter 'documentDirectoryId' must be defined and cannot be null.");
        else
            url_ += "documentDirectoryId=" + encodeURIComponent("" + documentDirectoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ResourceListDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceListDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ResourceListDto[]>(<any>null);
    }

    /**
     * listPage
     * @param filter filter
     * @param query query
     * @return OK
     */
    listPage(filter: any, query: string): Promise<IPageOfResourceListDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/list-page?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListPage(_response);
        });
    }

    protected processListPage(response: AxiosResponse): Promise<IPageOfResourceListDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfResourceListDto.fromJS(resultData200) : new IPageOfResourceListDto();
            return result200;
        }
        return Promise.resolve<IPageOfResourceListDto>(<any>null);
    }

    /**
     * publishedList
     * @param documentDirectoryId documentDirectoryId
     * @param filter filter
     * @return OK
     */
    publishedList(documentDirectoryId: string, filter: any): Promise<ResourceDetailDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/list-published?";
        if (documentDirectoryId === undefined || documentDirectoryId === null)
            throw new Error("The parameter 'documentDirectoryId' must be defined and cannot be null.");
        else
            url_ += "documentDirectoryId=" + encodeURIComponent("" + documentDirectoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishedList(_response);
        });
    }

    protected processPublishedList(response: AxiosResponse): Promise<ResourceDetailDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceDetailDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ResourceDetailDto[]>(<any>null);
    }

    /**
     * publish
     * @param resourceId resourceId
     * @return OK
     */
    publish(resourceId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/publish?";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined and cannot be null.");
        else
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * replaceFile
     * @param replaceFileDto replaceFileDto
     * @return OK
     */
    replaceFile(replaceFileDto: ReplaceResourceFileDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/replace-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(replaceFileDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReplaceFile(_response);
        });
    }

    protected processReplaceFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * resourceFileList
     * @param resourceId resourceId
     * @return OK
     */
    resourceFileList(resourceId: string): Promise<ResourceFileDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/resource-file-list?";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined and cannot be null.");
        else
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResourceFileList(_response);
        });
    }

    protected processResourceFileList(response: AxiosResponse): Promise<ResourceFileDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceFileDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ResourceFileDto[]>(<any>null);
    }

    /**
     * resourceVersionDetail
     * @param resourceId resourceId
     * @param versionId versionId
     * @return OK
     */
    resourceVersionDetail(resourceId: string, versionId: string): Promise<ResourceDetailDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/resource-version-detail?";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined and cannot be null.");
        else
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&"; 
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined and cannot be null.");
        else
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResourceVersionDetail(_response);
        });
    }

    protected processResourceVersionDetail(response: AxiosResponse): Promise<ResourceDetailDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ResourceDetailDto.fromJS(resultData200) : new ResourceDetailDto();
            return result200;
        }
        return Promise.resolve<ResourceDetailDto>(<any>null);
    }

    /**
     * switchVersion
     * @param resourceId resourceId
     * @param versionId versionId
     * @return OK
     */
    switchVersion(resourceId: string, versionId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/switch-version?";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined and cannot be null.");
        else
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&"; 
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined and cannot be null.");
        else
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSwitchVersion(_response);
        });
    }

    protected processSwitchVersion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * versionFileList
     * @param versionId versionId
     * @return OK
     */
    versionFileList(versionId: string): Promise<FileInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/version-file-list?";
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined and cannot be null.");
        else
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVersionFileList(_response);
        });
    }

    protected processVersionFileList(response: AxiosResponse): Promise<FileInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FileInfoVO[]>(<any>null);
    }

    /**
     * versionList
     * @param resourceId resourceId
     * @return OK
     */
    versionList(resourceId: string): Promise<ResourceVersionDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/versions?";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined and cannot be null.");
        else
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVersionList(_response);
        });
    }

    protected processVersionList(response: AxiosResponse): Promise<ResourceVersionDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceVersionDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ResourceVersionDto[]>(<any>null);
    }

    /**
     * update
     * @param id id
     * @param resourceDto resourceDto
     * @return OK
     */
    update(id: string, resourceDto: ResourceCreateOrUpdateDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/resources/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resourceDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class TransferDirectoryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 传输目录保存
     * @param transferDirectoryDto transferDirectoryDto
     * @return OK
     */
    save(transferDirectoryDto: TransferDirectoryDto): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferDirectoryDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 传输目录删除
     * @param id (optional) 传输目录id
     * @return OK
     */
    delete(id: string | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class TransferDirectoryGroupServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 传输目录分组删除
     * @param groupId (optional) 分组Id
     * @return OK
     */
    delete(groupId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory-group/delete/{groupId}";
        if (groupId !== null && groupId !== undefined)
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId)); 
        else
            url_ = url_.replace("/{groupId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 传输目录分组保存
     * @param transferDirectoryGroupDto transferDirectoryGroupDto
     * @return OK
     */
    save(transferDirectoryGroupDto: TransferDirectoryGroupDto): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory-group/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferDirectoryGroupDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取传输目录组树形结构
     * @return OK
     */
    treeList(): Promise<TransferDirectoryTreeDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory-group/treeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTreeList(_response);
        });
    }

    protected processTreeList(response: AxiosResponse): Promise<TransferDirectoryTreeDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransferDirectoryTreeDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TransferDirectoryTreeDto[]>(<any>null);
    }

    /**
     * 传输目录分组编辑
     * @param updateDto updateDto
     * @return OK
     */
    update(updateDto: TransferDirectoryGroupDto): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory-group/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class TransferDirectoryFileServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 传输目录文件批量删除
     * @param fileIdList fileIdList
     * @return OK
     */
    deleteBatchFile(fileIdList: string[]): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/batch-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileIdList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteBatchFile(_response);
        });
    }

    protected processDeleteBatchFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 是否名称重复
     * @param transferDirectoryFileDtoList transferDirectoryFileDtoList
     * @return OK
     */
    isDuplicateName(transferDirectoryFileDtoList: TransferDirectoryFileDto[]): Promise<DuplicateNameVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/duplicateName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferDirectoryFileDtoList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIsDuplicateName(_response);
        });
    }

    protected processIsDuplicateName(response: AxiosResponse): Promise<DuplicateNameVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DuplicateNameVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DuplicateNameVO[]>(<any>null);
    }

    /**
     * 传输目录文件保存
     * @param transferDirectoryFileDtoList transferDirectoryFileDtoList
     * @return OK
     */
    save(transferDirectoryFileDtoList: TransferDirectoryFileDto[]): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferDirectoryFileDtoList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 传输目录文件删除
     * @param fileId (optional) 文件Id
     * @return OK
     */
    delete(fileId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/file/{fileId}";
        if (fileId !== null && fileId !== undefined)
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId)); 
        else
            url_ = url_.replace("/{fileId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 传输目录资源文件保存
     * @param transferDirectoryFileDtoList transferDirectoryFileDtoList
     * @return OK
     */
    saveResource(transferDirectoryFileDtoList: TransferDirectoryFileDto[]): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/resource/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferDirectoryFileDtoList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveResource(_response);
        });
    }

    protected processSaveResource(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 传输目录文件删除
     * @param resourceId (optional) 资源Id
     * @return OK
     */
    deleteFileByResourceId(resourceId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/resource/{resourceId}";
        if (resourceId !== null && resourceId !== undefined)
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId)); 
        else
            url_ = url_.replace("/{resourceId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteFileByResourceId(_response);
        });
    }

    protected processDeleteFileByResourceId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TransferDirectoryFileQueryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 下载单个文件
     * @param fileId (optional) 文件Id
     * @return OK
     */
    downloadFile(fileId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/downloadFile/{fileId}";
        if (fileId !== null && fileId !== undefined)
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId)); 
        else
            url_ = url_.replace("/{fileId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取传输目录下的文件列表
     * @param fileName (optional) 模糊查询文件名
     * @param transferDirectoryId (optional) 传输目录id
     * @return OK
     */
    fileList(fileName: string | null | undefined, transferDirectoryId: string | null | undefined): Promise<TransferDirectoryFileDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/{transferDirectoryId}/fileList?";
        if (transferDirectoryId !== null && transferDirectoryId !== undefined)
        url_ = url_.replace("{transferDirectoryId}", encodeURIComponent("" + transferDirectoryId)); 
        else
            url_ = url_.replace("/{transferDirectoryId}", "");
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFileList(_response);
        });
    }

    protected processFileList(response: AxiosResponse): Promise<TransferDirectoryFileDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransferDirectoryFileDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TransferDirectoryFileDto[]>(<any>null);
    }

    /**
     * 获取传输目录下的文件列表(分页)
     * @param current (optional) 当前页
     * @param fileName (optional) 模糊查询文件名
     * @param size (optional) 每页的数量
     * @param transferDirectoryId (optional) 传输目录id
     * @return OK
     */
    fileListPage(current: number | null | undefined, fileName: string | null | undefined, size: number | null | undefined, transferDirectoryId: string | null | undefined): Promise<IPageOfTransferDirectoryFileDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/{transferDirectoryId}/fileListPage?";
        if (transferDirectoryId !== null && transferDirectoryId !== undefined)
        url_ = url_.replace("{transferDirectoryId}", encodeURIComponent("" + transferDirectoryId)); 
        else
            url_ = url_.replace("/{transferDirectoryId}", "");
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFileListPage(_response);
        });
    }

    protected processFileListPage(response: AxiosResponse): Promise<IPageOfTransferDirectoryFileDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfTransferDirectoryFileDto.fromJS(resultData200) : new IPageOfTransferDirectoryFileDto();
            return result200;
        }
        return Promise.resolve<IPageOfTransferDirectoryFileDto>(<any>null);
    }
}

export class TransferDirectoryQueryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取组下面的所有传输目录
     * @param groupId groupId
     * @return OK
     */
    list(groupId: string): Promise<TransferDirectoryDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/group/list?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<TransferDirectoryDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransferDirectoryDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TransferDirectoryDto[]>(<any>null);
    }

    /**
     * findTransferDirectoryList
     * @param groupId groupId
     * @return OK
     */
    findTransferDirectoryList(groupId: string): Promise<TransferDirectoryGroupListDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/transfer-directory-list?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindTransferDirectoryList(_response);
        });
    }

    protected processFindTransferDirectoryList(response: AxiosResponse): Promise<TransferDirectoryGroupListDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransferDirectoryGroupListDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TransferDirectoryGroupListDto[]>(<any>null);
    }

    /**
     * findTreeList
     * @return OK
     */
    findTreeList(): Promise<TransferDirectoryTreeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/tree-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindTreeList(_response);
        });
    }

    protected processFindTreeList(response: AxiosResponse): Promise<TransferDirectoryTreeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransferDirectoryTreeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TransferDirectoryTreeVO[]>(<any>null);
    }

    /**
     * hmi获取传输目录文件以及工艺文件
     * @param fileName (optional) 模糊查询文件名
     * @param transferDirectoryId (optional) 传输目录id
     * @return OK
     */
    hmiFileList(fileName: string | null | undefined, transferDirectoryId: string | null | undefined): Promise<HmiTransferFileDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-directory/{transferDirectoryId}/hmiFileList?";
        if (transferDirectoryId !== null && transferDirectoryId !== undefined)
        url_ = url_.replace("{transferDirectoryId}", encodeURIComponent("" + transferDirectoryId)); 
        else
            url_ = url_.replace("/{transferDirectoryId}", "");
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHmiFileList(_response);
        });
    }

    protected processHmiFileList(response: AxiosResponse): Promise<HmiTransferFileDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? HmiTransferFileDTO.fromJS(resultData200) : new HmiTransferFileDTO();
            return result200;
        }
        return Promise.resolve<HmiTransferFileDTO>(<any>null);
    }
}

export class TransferLogServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getPageByTransfer
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param transferId transferId
     * @return OK
     */
    getPageByTransfer(current: number | null | undefined, size: number | null | undefined, transferId: string): Promise<IPageOfTransferLogVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/app-dnc')+ "/transfer-logs/page-by-transfer?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (transferId === undefined || transferId === null)
            throw new Error("The parameter 'transferId' must be defined and cannot be null.");
        else
            url_ += "transferId=" + encodeURIComponent("" + transferId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageByTransfer(_response);
        });
    }

    protected processGetPageByTransfer(response: AxiosResponse): Promise<IPageOfTransferLogVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfTransferLogVO.fromJS(resultData200) : new IPageOfTransferLogVO();
            return result200;
        }
        return Promise.resolve<IPageOfTransferLogVO>(<any>null);
    }
}

export class ChangeFileParentDto implements IChangeFileParentDto {
    /** parentId */
    parentId!: string | undefined;
    sourceIdList!: number[];

    constructor(data?: IChangeFileParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sourceIdList = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            if (data["sourceIdList"] && data["sourceIdList"].constructor === Array) {
                this.sourceIdList = [] as any;
                for (let item of data["sourceIdList"])
                    this.sourceIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ChangeFileParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeFileParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        if (this.sourceIdList && this.sourceIdList.constructor === Array) {
            data["sourceIdList"] = [];
            for (let item of this.sourceIdList)
                data["sourceIdList"].push(item);
        }
        return data; 
    }
}

export interface IChangeFileParentDto {
    /** parentId */
    parentId: string | undefined;
    sourceIdList: number[];
}

export class CncUpdateFileNameDTO implements ICncUpdateFileNameDTO {
    /** appCode */
    appCode!: number | undefined;
    /** 文件名称 */
    fileNewName!: string | undefined;
    /** 文件名称 */
    fileOldName!: string | undefined;
    /** 网关code */
    gateWayCode!: string | undefined;

    constructor(data?: ICncUpdateFileNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.fileNewName = data["fileNewName"];
            this.fileOldName = data["fileOldName"];
            this.gateWayCode = data["gateWayCode"];
        }
    }

    static fromJS(data: any): CncUpdateFileNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CncUpdateFileNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["fileNewName"] = this.fileNewName;
        data["fileOldName"] = this.fileOldName;
        data["gateWayCode"] = this.gateWayCode;
        return data; 
    }
}

export interface ICncUpdateFileNameDTO {
    /** appCode */
    appCode: number | undefined;
    /** 文件名称 */
    fileNewName: string | undefined;
    /** 文件名称 */
    fileOldName: string | undefined;
    /** 网关code */
    gateWayCode: string | undefined;
}

export class CncWriteFileDTO implements ICncWriteFileDTO {
    /** appCode */
    appCode!: number | undefined;
    /** 文件内容 */
    content!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** 网关code */
    gateWayCode!: string | undefined;
    /** 偏移量 */
    length!: string | undefined;
    /** 文件的objectKey */
    objectKey!: string | undefined;
    /** 起始位置 */
    offset!: string | undefined;

    constructor(data?: ICncWriteFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.content = data["content"];
            this.fileName = data["fileName"];
            this.gateWayCode = data["gateWayCode"];
            this.length = data["length"];
            this.objectKey = data["objectKey"];
            this.offset = data["offset"];
        }
    }

    static fromJS(data: any): CncWriteFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CncWriteFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["content"] = this.content;
        data["fileName"] = this.fileName;
        data["gateWayCode"] = this.gateWayCode;
        data["length"] = this.length;
        data["objectKey"] = this.objectKey;
        data["offset"] = this.offset;
        return data; 
    }
}

export interface ICncWriteFileDTO {
    /** appCode */
    appCode: number | undefined;
    /** 文件内容 */
    content: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 网关code */
    gateWayCode: string | undefined;
    /** 偏移量 */
    length: string | undefined;
    /** 文件的objectKey */
    objectKey: string | undefined;
    /** 起始位置 */
    offset: string | undefined;
}

export class CreateFileDto implements ICreateFileDto {
    originalName!: string | undefined;
    ossFile!: OssFile | undefined;
    targetId!: string | undefined;

    constructor(data?: ICreateFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.originalName = data["originalName"];
            this.ossFile = data["ossFile"] ? OssFile.fromJS(data["ossFile"]) : <any>undefined;
            this.targetId = data["targetId"];
        }
    }

    static fromJS(data: any): CreateFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalName"] = this.originalName;
        data["ossFile"] = this.ossFile ? this.ossFile.toJSON() : <any>undefined;
        data["targetId"] = this.targetId;
        return data; 
    }
}

export interface ICreateFileDto {
    originalName: string | undefined;
    ossFile: OssFile | undefined;
    targetId: string | undefined;
}

export class DeleteFileDto implements IDeleteFileDto {
    sourceIdList!: string[] | undefined;

    constructor(data?: IDeleteFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["sourceIdList"] && data["sourceIdList"].constructor === Array) {
                this.sourceIdList = [] as any;
                for (let item of data["sourceIdList"])
                    this.sourceIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.sourceIdList && this.sourceIdList.constructor === Array) {
            data["sourceIdList"] = [];
            for (let item of this.sourceIdList)
                data["sourceIdList"].push(item);
        }
        return data; 
    }
}

export interface IDeleteFileDto {
    sourceIdList: string[] | undefined;
}

export class DirectoryDto implements IDirectoryDto {
    id!: string | undefined;
    list!: EntiryInfoDto[] | undefined;
    path!: string | undefined;

    constructor(data?: IDirectoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(EntiryInfoDto.fromJS(item));
            }
            this.path = data["path"];
        }
    }

    static fromJS(data: any): DirectoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["path"] = this.path;
        return data; 
    }
}

export interface IDirectoryDto {
    id: string | undefined;
    list: EntiryInfoDto[] | undefined;
    path: string | undefined;
}

export class DuplicateNameVO implements IDuplicateNameVO {
    /** 名称 */
    fileName!: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType!: number | undefined;

    constructor(data?: IDuplicateNameVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
        }
    }

    static fromJS(data: any): DuplicateNameVO {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateNameVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        return data; 
    }
}

export interface IDuplicateNameVO {
    /** 名称 */
    fileName: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType: number | undefined;
}

export class EntiryInfoDto implements IEntiryInfoDto {
    canWrite!: boolean | undefined;
    creationTime!: Date | undefined;
    hash!: string | undefined;
    id!: string | undefined;
    isDirectory!: boolean | undefined;
    name!: string | undefined;
    owner!: string | undefined;
    size!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IEntiryInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canWrite = data["canWrite"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.hash = data["hash"];
            this.id = data["id"];
            this.isDirectory = data["isDirectory"];
            this.name = data["name"];
            this.owner = data["owner"];
            this.size = data["size"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EntiryInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntiryInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canWrite"] = this.canWrite;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["hash"] = this.hash;
        data["id"] = this.id;
        data["isDirectory"] = this.isDirectory;
        data["name"] = this.name;
        data["owner"] = this.owner;
        data["size"] = this.size;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEntiryInfoDto {
    canWrite: boolean | undefined;
    creationTime: Date | undefined;
    hash: string | undefined;
    id: string | undefined;
    isDirectory: boolean | undefined;
    name: string | undefined;
    owner: string | undefined;
    size: string | undefined;
    updateTime: Date | undefined;
}

export class FileDto implements IFileDto {
    allPathName!: string | undefined;
    contentLength!: string | undefined;
    contentMd5!: string | undefined;
    contentType!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    fileType!: number | undefined;
    /** 主键Id */
    id!: string | undefined;
    name!: string | undefined;
    objectKey!: string | undefined;
    suffix!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allPathName = data["allPathName"];
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.fileType = data["fileType"];
            this.id = data["id"];
            this.name = data["name"];
            this.objectKey = data["objectKey"];
            this.suffix = data["suffix"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allPathName"] = this.allPathName;
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        data["name"] = this.name;
        data["objectKey"] = this.objectKey;
        data["suffix"] = this.suffix;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IFileDto {
    allPathName: string | undefined;
    contentLength: string | undefined;
    contentMd5: string | undefined;
    contentType: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    fileType: number | undefined;
    /** 主键Id */
    id: string | undefined;
    name: string | undefined;
    objectKey: string | undefined;
    suffix: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
}

export class FileInfoVO implements IFileInfoVO {
    /** 文件大小,必须大于等于0 */
    contentLength!: string | undefined;
    /** 文件H5 */
    contentMd5!: string | undefined;
    /** 内容类型，文件夹为null */
    contentType!: string | undefined;
    /** 名称 */
    displayName!: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType!: number | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 文件唯一标识 */
    objectKey!: string | undefined;
    /** 后缀名，文件夹为null */
    suffix!: string | undefined;

    constructor(data?: IFileInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.displayName = data["displayName"];
            this.fileType = data["fileType"];
            this.id = data["id"];
            this.objectKey = data["objectKey"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): FileInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new FileInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["displayName"] = this.displayName;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        data["objectKey"] = this.objectKey;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface IFileInfoVO {
    /** 文件大小,必须大于等于0 */
    contentLength: string | undefined;
    /** 文件H5 */
    contentMd5: string | undefined;
    /** 内容类型，文件夹为null */
    contentType: string | undefined;
    /** 名称 */
    displayName: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType: number | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 文件唯一标识 */
    objectKey: string | undefined;
    /** 后缀名，文件夹为null */
    suffix: string | undefined;
}

export class FileVersionDto implements IFileVersionDto {
    current!: boolean | undefined;
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IFileVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): FileVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IFileVersionDto {
    current: boolean | undefined;
    id: string | undefined;
    name: string | undefined;
}

export class FilterSchemaDto implements IFilterSchemaDto {
    schema!: any | undefined;

    constructor(data?: IFilterSchemaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schema = data["schema"];
        }
    }

    static fromJS(data: any): FilterSchemaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterSchemaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schema"] = this.schema;
        return data; 
    }
}

export interface IFilterSchemaDto {
    schema: any | undefined;
}

export class FolderDto implements IFolderDto {
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 主键Id */
    id!: string | undefined;
    name!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;

    constructor(data?: IFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IFolderDto {
    /** 创建时间 */
    createTime: Date | undefined;
    /** 主键Id */
    id: string | undefined;
    name: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
}

export class FolderListDto implements IFolderListDto {
    fileList!: FileDto[] | undefined;
    folderList!: FolderDto[] | undefined;

    constructor(data?: IFolderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["fileList"] && data["fileList"].constructor === Array) {
                this.fileList = [] as any;
                for (let item of data["fileList"])
                    this.fileList!.push(FileDto.fromJS(item));
            }
            if (data["folderList"] && data["folderList"].constructor === Array) {
                this.folderList = [] as any;
                for (let item of data["folderList"])
                    this.folderList!.push(FolderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FolderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.fileList && this.fileList.constructor === Array) {
            data["fileList"] = [];
            for (let item of this.fileList)
                data["fileList"].push(item.toJSON());
        }
        if (this.folderList && this.folderList.constructor === Array) {
            data["folderList"] = [];
            for (let item of this.folderList)
                data["folderList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFolderListDto {
    fileList: FileDto[] | undefined;
    folderList: FolderDto[] | undefined;
}

export class FormFieldDto implements IFormFieldDto {
    code!: string | undefined;
    dataSource!: LabelValueDto[] | undefined;
    defaultValue!: string | undefined;
    isEnabled!: boolean | undefined;
    isRequired!: boolean | undefined;
    isSystem!: boolean | undefined;
    jsonType!: FormFieldDtoJsonType | undefined;
    optional!: string | undefined;
    placeholder!: string | undefined;
    props!: NameValueOfstring[] | undefined;
    sort!: number | undefined;
    title!: string | undefined;
    widget!: FormFieldDtoWidget | undefined;

    constructor(data?: IFormFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["dataSource"] && data["dataSource"].constructor === Array) {
                this.dataSource = [] as any;
                for (let item of data["dataSource"])
                    this.dataSource!.push(LabelValueDto.fromJS(item));
            }
            this.defaultValue = data["defaultValue"];
            this.isEnabled = data["isEnabled"];
            this.isRequired = data["isRequired"];
            this.isSystem = data["isSystem"];
            this.jsonType = data["jsonType"];
            this.optional = data["optional"];
            this.placeholder = data["placeholder"];
            if (data["props"] && data["props"].constructor === Array) {
                this.props = [] as any;
                for (let item of data["props"])
                    this.props!.push(NameValueOfstring.fromJS(item));
            }
            this.sort = data["sort"];
            this.title = data["title"];
            this.widget = data["widget"];
        }
    }

    static fromJS(data: any): FormFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.dataSource && this.dataSource.constructor === Array) {
            data["dataSource"] = [];
            for (let item of this.dataSource)
                data["dataSource"].push(item.toJSON());
        }
        data["defaultValue"] = this.defaultValue;
        data["isEnabled"] = this.isEnabled;
        data["isRequired"] = this.isRequired;
        data["isSystem"] = this.isSystem;
        data["jsonType"] = this.jsonType;
        data["optional"] = this.optional;
        data["placeholder"] = this.placeholder;
        if (this.props && this.props.constructor === Array) {
            data["props"] = [];
            for (let item of this.props)
                data["props"].push(item.toJSON());
        }
        data["sort"] = this.sort;
        data["title"] = this.title;
        data["widget"] = this.widget;
        return data; 
    }
}

export interface IFormFieldDto {
    code: string | undefined;
    dataSource: LabelValueDto[] | undefined;
    defaultValue: string | undefined;
    isEnabled: boolean | undefined;
    isRequired: boolean | undefined;
    isSystem: boolean | undefined;
    jsonType: FormFieldDtoJsonType | undefined;
    optional: string | undefined;
    placeholder: string | undefined;
    props: NameValueOfstring[] | undefined;
    sort: number | undefined;
    title: string | undefined;
    widget: FormFieldDtoWidget | undefined;
}

export class FormSchemaDto implements IFormSchemaDto {
    schema!: any | undefined;

    constructor(data?: IFormSchemaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schema = data["schema"];
        }
    }

    static fromJS(data: any): FormSchemaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSchemaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schema"] = this.schema;
        return data; 
    }
}

export interface IFormSchemaDto {
    schema: any | undefined;
}

export class HmiTransferFileDTO implements IHmiTransferFileDTO {
    /** 工艺文件 */
    resourceFileDtoList!: ResourceFileDto[] | undefined;
    /** 传输目录文件 */
    transferDirectoryFileList!: TransferDirectoryFileDto[] | undefined;

    constructor(data?: IHmiTransferFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["resourceFileDtoList"] && data["resourceFileDtoList"].constructor === Array) {
                this.resourceFileDtoList = [] as any;
                for (let item of data["resourceFileDtoList"])
                    this.resourceFileDtoList!.push(ResourceFileDto.fromJS(item));
            }
            if (data["transferDirectoryFileList"] && data["transferDirectoryFileList"].constructor === Array) {
                this.transferDirectoryFileList = [] as any;
                for (let item of data["transferDirectoryFileList"])
                    this.transferDirectoryFileList!.push(TransferDirectoryFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HmiTransferFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HmiTransferFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.resourceFileDtoList && this.resourceFileDtoList.constructor === Array) {
            data["resourceFileDtoList"] = [];
            for (let item of this.resourceFileDtoList)
                data["resourceFileDtoList"].push(item.toJSON());
        }
        if (this.transferDirectoryFileList && this.transferDirectoryFileList.constructor === Array) {
            data["transferDirectoryFileList"] = [];
            for (let item of this.transferDirectoryFileList)
                data["transferDirectoryFileList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IHmiTransferFileDTO {
    /** 工艺文件 */
    resourceFileDtoList: ResourceFileDto[] | undefined;
    /** 传输目录文件 */
    transferDirectoryFileList: TransferDirectoryFileDto[] | undefined;
}

export class IPageOfResourceListDto implements IIPageOfResourceListDto {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ResourceListDto[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfResourceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ResourceListDto.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfResourceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfResourceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfResourceListDto {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ResourceListDto[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfTransferDirectoryFileDto implements IIPageOfTransferDirectoryFileDto {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: TransferDirectoryFileDto[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfTransferDirectoryFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(TransferDirectoryFileDto.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfTransferDirectoryFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfTransferDirectoryFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfTransferDirectoryFileDto {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: TransferDirectoryFileDto[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfTransferLogVO implements IIPageOfTransferLogVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: TransferLogVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfTransferLogVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(TransferLogVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfTransferLogVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfTransferLogVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfTransferLogVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: TransferLogVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class LabelValueDto implements ILabelValueDto {
    label!: string | undefined;
    value!: string | undefined;

    constructor(data?: ILabelValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): LabelValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data; 
    }
}

export interface ILabelValueDto {
    label: string | undefined;
    value: string | undefined;
}

export class ManageDirectoryDto implements IManageDirectoryDto {
    /** 职权域Id */
    authorityId!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 是否管理目录设置(0:否，1：是) */
    isSetting!: number | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 父级节点的all_path */
    parentAllPath!: string | undefined;
    /** 父级节点 */
    parentId!: string | undefined;

    constructor(data?: IManageDirectoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authorityId = data["authorityId"];
            this.id = data["id"];
            this.isSetting = data["isSetting"];
            this.name = data["name"];
            this.parentAllPath = data["parentAllPath"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): ManageDirectoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageDirectoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorityId"] = this.authorityId;
        data["id"] = this.id;
        data["isSetting"] = this.isSetting;
        data["name"] = this.name;
        data["parentAllPath"] = this.parentAllPath;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface IManageDirectoryDto {
    /** 职权域Id */
    authorityId: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 是否管理目录设置(0:否，1：是) */
    isSetting: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 父级节点的all_path */
    parentAllPath: string | undefined;
    /** 父级节点 */
    parentId: string | undefined;
}

export class ManageDirectoryOutDto implements IManageDirectoryOutDto {
    /** all_path */
    allPath!: string | undefined;
    /** 职权域Id */
    authorityId!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 是否管理目录设置(0:否，1：是) */
    isSetting!: number | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 父级节点 */
    parentId!: string | undefined;

    constructor(data?: IManageDirectoryOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allPath = data["allPath"];
            this.authorityId = data["authorityId"];
            this.id = data["id"];
            this.isSetting = data["isSetting"];
            this.name = data["name"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): ManageDirectoryOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageDirectoryOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allPath"] = this.allPath;
        data["authorityId"] = this.authorityId;
        data["id"] = this.id;
        data["isSetting"] = this.isSetting;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface IManageDirectoryOutDto {
    /** all_path */
    allPath: string | undefined;
    /** 职权域Id */
    authorityId: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 是否管理目录设置(0:否，1：是) */
    isSetting: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 父级节点 */
    parentId: string | undefined;
}

export class ManageDirectoryTreeDto implements IManageDirectoryTreeDto {
    attribute!: any | undefined;
    children!: ManageDirectoryTreeDto[] | undefined;
    data!: ManageDirectoryOutDto | undefined;
    id!: string | undefined;
    key!: string | undefined;
    parentId!: string | undefined;
    title!: string | undefined;
    value!: string | undefined;

    constructor(data?: IManageDirectoryTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attribute = data["attribute"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(ManageDirectoryTreeDto.fromJS(item));
            }
            this.data = data["data"] ? ManageDirectoryOutDto.fromJS(data["data"]) : <any>undefined;
            this.id = data["id"];
            this.key = data["key"];
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ManageDirectoryTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageDirectoryTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["value"] = this.value;
        return data; 
    }
}

export interface IManageDirectoryTreeDto {
    attribute: any | undefined;
    children: ManageDirectoryTreeDto[] | undefined;
    data: ManageDirectoryOutDto | undefined;
    id: string | undefined;
    key: string | undefined;
    parentId: string | undefined;
    title: string | undefined;
    value: string | undefined;
}

export class MyFileDto implements IMyFileDto {
    allPathName!: string | undefined;
    contentLength!: string | undefined;
    contentMd5!: string | undefined;
    contentType!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 主键Id */
    id!: string | undefined;
    name!: string | undefined;
    objectKey!: string | undefined;
    /** 父级Id */
    parentId!: string | undefined;
    suffix!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;

    constructor(data?: IMyFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allPathName = data["allPathName"];
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.objectKey = data["objectKey"];
            this.parentId = data["parentId"];
            this.suffix = data["suffix"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MyFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allPathName"] = this.allPathName;
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["objectKey"] = this.objectKey;
        data["parentId"] = this.parentId;
        data["suffix"] = this.suffix;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMyFileDto {
    allPathName: string | undefined;
    contentLength: string | undefined;
    contentMd5: string | undefined;
    contentType: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 主键Id */
    id: string | undefined;
    name: string | undefined;
    objectKey: string | undefined;
    /** 父级Id */
    parentId: string | undefined;
    suffix: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
}

export class MyFolderDto implements IMyFolderDto {
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 主键Id */
    id!: string | undefined;
    name!: string | undefined;
    /** 父级Id */
    parentId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;

    constructor(data?: IMyFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.parentId = data["parentId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MyFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyFolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMyFolderDto {
    /** 创建时间 */
    createTime: Date | undefined;
    /** 主键Id */
    id: string | undefined;
    name: string | undefined;
    /** 父级Id */
    parentId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
}

export class MyFolderListDto implements IMyFolderListDto {
    fileList!: MyFileDto[] | undefined;
    folderList!: MyFolderDto[] | undefined;

    constructor(data?: IMyFolderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["fileList"] && data["fileList"].constructor === Array) {
                this.fileList = [] as any;
                for (let item of data["fileList"])
                    this.fileList!.push(MyFileDto.fromJS(item));
            }
            if (data["folderList"] && data["folderList"].constructor === Array) {
                this.folderList = [] as any;
                for (let item of data["folderList"])
                    this.folderList!.push(MyFolderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyFolderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyFolderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.fileList && this.fileList.constructor === Array) {
            data["fileList"] = [];
            for (let item of this.fileList)
                data["fileList"].push(item.toJSON());
        }
        if (this.folderList && this.folderList.constructor === Array) {
            data["folderList"] = [];
            for (let item of this.folderList)
                data["folderList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMyFolderListDto {
    fileList: MyFileDto[] | undefined;
    folderList: MyFolderDto[] | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueOfstring implements INameValueOfstring {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfstring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfstring {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfstring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfstring {
    name: string | undefined;
    value: string | undefined;
}

export class NewFolderDto implements INewFolderDto {
    /** 文件大小 */
    contentLength!: string | undefined;
    /** 文件md5值 */
    contentMd5!: string | undefined;
    /** 对象MIME类型 */
    contentType!: string | undefined;
    /** 文件名 */
    displayName!: string | undefined;
    fileType!: NewFolderDtoFileType | undefined;
    /** 主键id */
    id!: string | undefined;
    name!: string;
    /** 文件的objectKey */
    objectKey!: string | undefined;
    owner!: string | undefined;
    parent!: string | undefined;
    /** 后缀名 */
    suffix!: string | undefined;

    constructor(data?: INewFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.displayName = data["displayName"];
            this.fileType = data["fileType"];
            this.id = data["id"];
            this.name = data["name"];
            this.objectKey = data["objectKey"];
            this.owner = data["owner"];
            this.parent = data["parent"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): NewFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewFolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["displayName"] = this.displayName;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        data["name"] = this.name;
        data["objectKey"] = this.objectKey;
        data["owner"] = this.owner;
        data["parent"] = this.parent;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface INewFolderDto {
    /** 文件大小 */
    contentLength: string | undefined;
    /** 文件md5值 */
    contentMd5: string | undefined;
    /** 对象MIME类型 */
    contentType: string | undefined;
    /** 文件名 */
    displayName: string | undefined;
    fileType: NewFolderDtoFileType | undefined;
    /** 主键id */
    id: string | undefined;
    name: string;
    /** 文件的objectKey */
    objectKey: string | undefined;
    owner: string | undefined;
    parent: string | undefined;
    /** 后缀名 */
    suffix: string | undefined;
}

export class OssFile implements IOssFile {
    contentType!: string | undefined;
    hash!: string | undefined;
    length!: string | undefined;
    link!: string | undefined;
    name!: string | undefined;
    putTime!: Date | undefined;

    constructor(data?: IOssFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.hash = data["hash"];
            this.length = data["length"];
            this.link = data["link"];
            this.name = data["name"];
            this.putTime = data["putTime"] ? new Date(data["putTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OssFile {
        data = typeof data === 'object' ? data : {};
        let result = new OssFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["hash"] = this.hash;
        data["length"] = this.length;
        data["link"] = this.link;
        data["name"] = this.name;
        data["putTime"] = this.putTime ? this.putTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IOssFile {
    contentType: string | undefined;
    hash: string | undefined;
    length: string | undefined;
    link: string | undefined;
    name: string | undefined;
    putTime: Date | undefined;
}

/** 返回信息 */
export class R implements IR {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): R {
        data = typeof data === 'object' ? data : {};
        let result = new R();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IR {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class RenameDto implements IRenameDto {
    fileType!: number;
    newName!: string;
    parentId!: string;

    constructor(data?: IRenameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileType = data["fileType"];
            this.newName = data["newName"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): RenameDto {
        data = typeof data === 'object' ? data : {};
        let result = new RenameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType;
        data["newName"] = this.newName;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface IRenameDto {
    fileType: number;
    newName: string;
    parentId: string;
}

export class ReplaceResourceFileDto implements IReplaceResourceFileDto {
    newFile!: FileInfoVO | undefined;
    oldFileId!: string | undefined;
    resourceId!: string | undefined;

    constructor(data?: IReplaceResourceFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newFile = data["newFile"] ? FileInfoVO.fromJS(data["newFile"]) : <any>undefined;
            this.oldFileId = data["oldFileId"];
            this.resourceId = data["resourceId"];
        }
    }

    static fromJS(data: any): ReplaceResourceFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplaceResourceFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newFile"] = this.newFile ? this.newFile.toJSON() : <any>undefined;
        data["oldFileId"] = this.oldFileId;
        data["resourceId"] = this.resourceId;
        return data; 
    }
}

export interface IReplaceResourceFileDto {
    newFile: FileInfoVO | undefined;
    oldFileId: string | undefined;
    resourceId: string | undefined;
}

export class ResourceCreateOrUpdateDto implements IResourceCreateOrUpdateDto {
    files!: FileInfoVO[] | undefined;
    resource!: ResourceDto | undefined;

    constructor(data?: IResourceCreateOrUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["files"] && data["files"].constructor === Array) {
                this.files = [] as any;
                for (let item of data["files"])
                    this.files!.push(FileInfoVO.fromJS(item));
            }
            this.resource = data["resource"] ? ResourceDto.fromJS(data["resource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResourceCreateOrUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceCreateOrUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.files && this.files.constructor === Array) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["resource"] = this.resource ? this.resource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IResourceCreateOrUpdateDto {
    files: FileInfoVO[] | undefined;
    resource: ResourceDto | undefined;
}

export class ResourceDetailDto implements IResourceDetailDto {
    code!: string;
    currentVersion!: string | undefined;
    /** currentVersionId */
    currentVersionId!: string | undefined;
    displayName!: string;
    /** documentDirectory */
    documentDirectory!: string | undefined;
    extendContent!: any | undefined;
    fileList!: FileInfoVO[] | undefined;
    /** 主键Id */
    id!: string | undefined;
    nameValues!: NameValueDto[] | undefined;
    publishDatetime!: Date | undefined;
    state!: ResourceDetailDtoState | undefined;

    constructor(data?: IResourceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.currentVersion = data["currentVersion"];
            this.currentVersionId = data["currentVersionId"];
            this.displayName = data["displayName"];
            this.documentDirectory = data["documentDirectory"];
            this.extendContent = data["extendContent"];
            if (data["fileList"] && data["fileList"].constructor === Array) {
                this.fileList = [] as any;
                for (let item of data["fileList"])
                    this.fileList!.push(FileInfoVO.fromJS(item));
            }
            this.id = data["id"];
            if (data["nameValues"] && data["nameValues"].constructor === Array) {
                this.nameValues = [] as any;
                for (let item of data["nameValues"])
                    this.nameValues!.push(NameValueDto.fromJS(item));
            }
            this.publishDatetime = data["publishDatetime"] ? new Date(data["publishDatetime"].toString()) : <any>undefined;
            this.state = data["state"];
        }
    }

    static fromJS(data: any): ResourceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["currentVersion"] = this.currentVersion;
        data["currentVersionId"] = this.currentVersionId;
        data["displayName"] = this.displayName;
        data["documentDirectory"] = this.documentDirectory;
        data["extendContent"] = this.extendContent;
        if (this.fileList && this.fileList.constructor === Array) {
            data["fileList"] = [];
            for (let item of this.fileList)
                data["fileList"].push(item.toJSON());
        }
        data["id"] = this.id;
        if (this.nameValues && this.nameValues.constructor === Array) {
            data["nameValues"] = [];
            for (let item of this.nameValues)
                data["nameValues"].push(item.toJSON());
        }
        data["publishDatetime"] = this.publishDatetime ? this.publishDatetime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data; 
    }
}

export interface IResourceDetailDto {
    code: string;
    currentVersion: string | undefined;
    /** currentVersionId */
    currentVersionId: string | undefined;
    displayName: string;
    /** documentDirectory */
    documentDirectory: string | undefined;
    extendContent: any | undefined;
    fileList: FileInfoVO[] | undefined;
    /** 主键Id */
    id: string | undefined;
    nameValues: NameValueDto[] | undefined;
    publishDatetime: Date | undefined;
    state: ResourceDetailDtoState | undefined;
}

export class ResourceDto implements IResourceDto {
    code!: string;
    displayName!: string;
    /** documentDirectory */
    documentDirectory!: string | undefined;
    extendContent!: any | undefined;

    constructor(data?: IResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.documentDirectory = data["documentDirectory"];
            this.extendContent = data["extendContent"];
        }
    }

    static fromJS(data: any): ResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["documentDirectory"] = this.documentDirectory;
        data["extendContent"] = this.extendContent;
        return data; 
    }
}

export interface IResourceDto {
    code: string;
    displayName: string;
    /** documentDirectory */
    documentDirectory: string | undefined;
    extendContent: any | undefined;
}

export class ResourceFileDto implements IResourceFileDto {
    contentLength!: string | undefined;
    contentMd5!: string | undefined;
    contentType!: string | undefined;
    createDatetime!: Date | undefined;
    /** createUserId */
    createUserId!: string | undefined;
    displayName!: string | undefined;
    fileType!: number | undefined;
    /** 主键Id */
    id!: string | undefined;
    objectKey!: string | undefined;
    /** resourceId */
    resourceId!: string | undefined;
    suffix!: string | undefined;

    constructor(data?: IResourceFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.createDatetime = data["createDatetime"] ? new Date(data["createDatetime"].toString()) : <any>undefined;
            this.createUserId = data["createUserId"];
            this.displayName = data["displayName"];
            this.fileType = data["fileType"];
            this.id = data["id"];
            this.objectKey = data["objectKey"];
            this.resourceId = data["resourceId"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): ResourceFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["createDatetime"] = this.createDatetime ? this.createDatetime.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["displayName"] = this.displayName;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        data["objectKey"] = this.objectKey;
        data["resourceId"] = this.resourceId;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface IResourceFileDto {
    contentLength: string | undefined;
    contentMd5: string | undefined;
    contentType: string | undefined;
    createDatetime: Date | undefined;
    /** createUserId */
    createUserId: string | undefined;
    displayName: string | undefined;
    fileType: number | undefined;
    /** 主键Id */
    id: string | undefined;
    objectKey: string | undefined;
    /** resourceId */
    resourceId: string | undefined;
    suffix: string | undefined;
}

export class ResourceListDto implements IResourceListDto {
    code!: string;
    currentVersion!: string | undefined;
    displayName!: string;
    /** documentDirectory */
    documentDirectory!: string | undefined;
    extendContent!: any | undefined;
    /** 主键Id */
    id!: string | undefined;
    state!: ResourceListDtoState | undefined;

    constructor(data?: IResourceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.currentVersion = data["currentVersion"];
            this.displayName = data["displayName"];
            this.documentDirectory = data["documentDirectory"];
            this.extendContent = data["extendContent"];
            this.id = data["id"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): ResourceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["currentVersion"] = this.currentVersion;
        data["displayName"] = this.displayName;
        data["documentDirectory"] = this.documentDirectory;
        data["extendContent"] = this.extendContent;
        data["id"] = this.id;
        data["state"] = this.state;
        return data; 
    }
}

export interface IResourceListDto {
    code: string;
    currentVersion: string | undefined;
    displayName: string;
    /** documentDirectory */
    documentDirectory: string | undefined;
    extendContent: any | undefined;
    /** 主键Id */
    id: string | undefined;
    state: ResourceListDtoState | undefined;
}

export class ResourceVersionDto implements IResourceVersionDto {
    currentUsed!: boolean | undefined;
    displayName!: string | undefined;
    /** 主键Id */
    id!: string | undefined;

    constructor(data?: IResourceVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentUsed = data["currentUsed"];
            this.displayName = data["displayName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ResourceVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentUsed"] = this.currentUsed;
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IResourceVersionDto {
    currentUsed: boolean | undefined;
    displayName: string | undefined;
    /** 主键Id */
    id: string | undefined;
}

export class TableColumnDto implements ITableColumnDto {
    code!: string | undefined;
    dataSource!: LabelValueDto[] | undefined;
    defaultValue!: string | undefined;
    isDisplay!: boolean | undefined;
    isEnabled!: boolean | undefined;
    isRequired!: boolean | undefined;
    isSystem!: boolean | undefined;
    jsonType!: TableColumnDtoJsonType | undefined;
    optional!: string | undefined;
    placeholder!: string | undefined;
    props!: NameValueOfstring[] | undefined;
    sort!: number | undefined;
    title!: string | undefined;
    widget!: TableColumnDtoWidget | undefined;

    constructor(data?: ITableColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["dataSource"] && data["dataSource"].constructor === Array) {
                this.dataSource = [] as any;
                for (let item of data["dataSource"])
                    this.dataSource!.push(LabelValueDto.fromJS(item));
            }
            this.defaultValue = data["defaultValue"];
            this.isDisplay = data["isDisplay"];
            this.isEnabled = data["isEnabled"];
            this.isRequired = data["isRequired"];
            this.isSystem = data["isSystem"];
            this.jsonType = data["jsonType"];
            this.optional = data["optional"];
            this.placeholder = data["placeholder"];
            if (data["props"] && data["props"].constructor === Array) {
                this.props = [] as any;
                for (let item of data["props"])
                    this.props!.push(NameValueOfstring.fromJS(item));
            }
            this.sort = data["sort"];
            this.title = data["title"];
            this.widget = data["widget"];
        }
    }

    static fromJS(data: any): TableColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new TableColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.dataSource && this.dataSource.constructor === Array) {
            data["dataSource"] = [];
            for (let item of this.dataSource)
                data["dataSource"].push(item.toJSON());
        }
        data["defaultValue"] = this.defaultValue;
        data["isDisplay"] = this.isDisplay;
        data["isEnabled"] = this.isEnabled;
        data["isRequired"] = this.isRequired;
        data["isSystem"] = this.isSystem;
        data["jsonType"] = this.jsonType;
        data["optional"] = this.optional;
        data["placeholder"] = this.placeholder;
        if (this.props && this.props.constructor === Array) {
            data["props"] = [];
            for (let item of this.props)
                data["props"].push(item.toJSON());
        }
        data["sort"] = this.sort;
        data["title"] = this.title;
        data["widget"] = this.widget;
        return data; 
    }
}

export interface ITableColumnDto {
    code: string | undefined;
    dataSource: LabelValueDto[] | undefined;
    defaultValue: string | undefined;
    isDisplay: boolean | undefined;
    isEnabled: boolean | undefined;
    isRequired: boolean | undefined;
    isSystem: boolean | undefined;
    jsonType: TableColumnDtoJsonType | undefined;
    optional: string | undefined;
    placeholder: string | undefined;
    props: NameValueOfstring[] | undefined;
    sort: number | undefined;
    title: string | undefined;
    widget: TableColumnDtoWidget | undefined;
}

export class TransferDirectoryDto implements ITransferDirectoryDto {
    /** 传输目录组all_path_name */
    allPathName!: string | undefined;
    /** 职权域Id */
    deptId!: string | undefined;
    /** 传输目录组的all_path */
    groupAllPath!: string | undefined;
    /** 传输目录组Id */
    groupId!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 传输目录name */
    name!: string | undefined;
    /** 传输目录图片 */
    picture!: string | undefined;

    constructor(data?: ITransferDirectoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allPathName = data["allPathName"];
            this.deptId = data["deptId"];
            this.groupAllPath = data["groupAllPath"];
            this.groupId = data["groupId"];
            this.id = data["id"];
            this.name = data["name"];
            this.picture = data["picture"];
        }
    }

    static fromJS(data: any): TransferDirectoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDirectoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allPathName"] = this.allPathName;
        data["deptId"] = this.deptId;
        data["groupAllPath"] = this.groupAllPath;
        data["groupId"] = this.groupId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["picture"] = this.picture;
        return data; 
    }
}

export interface ITransferDirectoryDto {
    /** 传输目录组all_path_name */
    allPathName: string | undefined;
    /** 职权域Id */
    deptId: string | undefined;
    /** 传输目录组的all_path */
    groupAllPath: string | undefined;
    /** 传输目录组Id */
    groupId: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 传输目录name */
    name: string | undefined;
    /** 传输目录图片 */
    picture: string | undefined;
}

export class TransferDirectoryFile implements ITransferDirectoryFile {
    contentLength!: string | undefined;
    contentMd5!: string | undefined;
    contentType!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    fileSource!: number | undefined;
    fileType!: number | undefined;
    filename!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    lastModified!: Date | undefined;
    objectKey!: string | undefined;
    originalFilename!: string | undefined;
    resourceId!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    suffix!: string | undefined;
    transferDirectoryId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;
    versionId!: string | undefined;

    constructor(data?: ITransferDirectoryFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.fileSource = data["fileSource"];
            this.fileType = data["fileType"];
            this.filename = data["filename"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.lastModified = data["lastModified"] ? new Date(data["lastModified"].toString()) : <any>undefined;
            this.objectKey = data["objectKey"];
            this.originalFilename = data["originalFilename"];
            this.resourceId = data["resourceId"];
            this.status = data["status"];
            this.suffix = data["suffix"];
            this.transferDirectoryId = data["transferDirectoryId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
            this.versionId = data["versionId"];
        }
    }

    static fromJS(data: any): TransferDirectoryFile {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDirectoryFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["fileSource"] = this.fileSource;
        data["fileType"] = this.fileType;
        data["filename"] = this.filename;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["objectKey"] = this.objectKey;
        data["originalFilename"] = this.originalFilename;
        data["resourceId"] = this.resourceId;
        data["status"] = this.status;
        data["suffix"] = this.suffix;
        data["transferDirectoryId"] = this.transferDirectoryId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        data["versionId"] = this.versionId;
        return data; 
    }
}

export interface ITransferDirectoryFile {
    contentLength: string | undefined;
    contentMd5: string | undefined;
    contentType: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    fileSource: number | undefined;
    fileType: number | undefined;
    filename: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    lastModified: Date | undefined;
    objectKey: string | undefined;
    originalFilename: string | undefined;
    resourceId: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    suffix: string | undefined;
    transferDirectoryId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
    versionId: string | undefined;
}

export class TransferDirectoryFileDto implements ITransferDirectoryFileDto {
    /** 文件大小 */
    contentLength!: string | undefined;
    /** 文件md5值 */
    contentMd5!: string | undefined;
    /** 对象MIME类型 */
    contentType!: string | undefined;
    /** 文件来源 */
    fileSource!: number | undefined;
    /** 文件类别 */
    fileType!: number | undefined;
    /** 文件名 */
    filename!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 文件最后修改时间 */
    lastModified!: Date | undefined;
    /** 文件的objectKey */
    objectKey!: string | undefined;
    /** 原始文件名 */
    originalFilename!: string | undefined;
    /** 资源Id */
    resourceId!: string | undefined;
    /** 文件的后缀 */
    suffix!: string | undefined;
    /** 传输目录Id */
    transferDirectoryId!: string | undefined;
    /** 资源版本Id */
    versionId!: string | undefined;

    constructor(data?: ITransferDirectoryFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.fileSource = data["fileSource"];
            this.fileType = data["fileType"];
            this.filename = data["filename"];
            this.id = data["id"];
            this.lastModified = data["lastModified"] ? new Date(data["lastModified"].toString()) : <any>undefined;
            this.objectKey = data["objectKey"];
            this.originalFilename = data["originalFilename"];
            this.resourceId = data["resourceId"];
            this.suffix = data["suffix"];
            this.transferDirectoryId = data["transferDirectoryId"];
            this.versionId = data["versionId"];
        }
    }

    static fromJS(data: any): TransferDirectoryFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDirectoryFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["fileSource"] = this.fileSource;
        data["fileType"] = this.fileType;
        data["filename"] = this.filename;
        data["id"] = this.id;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["objectKey"] = this.objectKey;
        data["originalFilename"] = this.originalFilename;
        data["resourceId"] = this.resourceId;
        data["suffix"] = this.suffix;
        data["transferDirectoryId"] = this.transferDirectoryId;
        data["versionId"] = this.versionId;
        return data; 
    }
}

export interface ITransferDirectoryFileDto {
    /** 文件大小 */
    contentLength: string | undefined;
    /** 文件md5值 */
    contentMd5: string | undefined;
    /** 对象MIME类型 */
    contentType: string | undefined;
    /** 文件来源 */
    fileSource: number | undefined;
    /** 文件类别 */
    fileType: number | undefined;
    /** 文件名 */
    filename: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 文件最后修改时间 */
    lastModified: Date | undefined;
    /** 文件的objectKey */
    objectKey: string | undefined;
    /** 原始文件名 */
    originalFilename: string | undefined;
    /** 资源Id */
    resourceId: string | undefined;
    /** 文件的后缀 */
    suffix: string | undefined;
    /** 传输目录Id */
    transferDirectoryId: string | undefined;
    /** 资源版本Id */
    versionId: string | undefined;
}

export class TransferDirectoryGroupDto implements ITransferDirectoryGroupDto {
    /** 主键Id */
    id!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 父级节点的all_path */
    parentAllPath!: string | undefined;
    /** 父级节点 */
    parentId!: string | undefined;

    constructor(data?: ITransferDirectoryGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.parentAllPath = data["parentAllPath"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): TransferDirectoryGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDirectoryGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentAllPath"] = this.parentAllPath;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface ITransferDirectoryGroupDto {
    /** 主键Id */
    id: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 父级节点的all_path */
    parentAllPath: string | undefined;
    /** 父级节点 */
    parentId: string | undefined;
}

export class TransferDirectoryGroupListDto implements ITransferDirectoryGroupListDto {
    /** 传输目录组all_path_name */
    allPathName!: string | undefined;
    /** 职权域Id */
    deptId!: string | undefined;
    /** 传输目录组的all_path */
    groupAllPath!: string | undefined;
    /** 传输目录组Id */
    groupId!: string | undefined;
    hasResource!: boolean | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 传输目录name */
    name!: string | undefined;
    /** 传输目录图片 */
    picture!: string | undefined;
    resourceDisplayName!: string | undefined;
    /** resourceId */
    resourceId!: string | undefined;
    /** versionId */
    versionId!: string | undefined;
    versionName!: string | undefined;

    constructor(data?: ITransferDirectoryGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allPathName = data["allPathName"];
            this.deptId = data["deptId"];
            this.groupAllPath = data["groupAllPath"];
            this.groupId = data["groupId"];
            this.hasResource = data["hasResource"];
            this.id = data["id"];
            this.name = data["name"];
            this.picture = data["picture"];
            this.resourceDisplayName = data["resourceDisplayName"];
            this.resourceId = data["resourceId"];
            this.versionId = data["versionId"];
            this.versionName = data["versionName"];
        }
    }

    static fromJS(data: any): TransferDirectoryGroupListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDirectoryGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allPathName"] = this.allPathName;
        data["deptId"] = this.deptId;
        data["groupAllPath"] = this.groupAllPath;
        data["groupId"] = this.groupId;
        data["hasResource"] = this.hasResource;
        data["id"] = this.id;
        data["name"] = this.name;
        data["picture"] = this.picture;
        data["resourceDisplayName"] = this.resourceDisplayName;
        data["resourceId"] = this.resourceId;
        data["versionId"] = this.versionId;
        data["versionName"] = this.versionName;
        return data; 
    }
}

export interface ITransferDirectoryGroupListDto {
    /** 传输目录组all_path_name */
    allPathName: string | undefined;
    /** 职权域Id */
    deptId: string | undefined;
    /** 传输目录组的all_path */
    groupAllPath: string | undefined;
    /** 传输目录组Id */
    groupId: string | undefined;
    hasResource: boolean | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 传输目录name */
    name: string | undefined;
    /** 传输目录图片 */
    picture: string | undefined;
    resourceDisplayName: string | undefined;
    /** resourceId */
    resourceId: string | undefined;
    /** versionId */
    versionId: string | undefined;
    versionName: string | undefined;
}

export class TransferDirectoryGroupOutDto implements ITransferDirectoryGroupOutDto {
    /** 当前节点的all_path */
    allPath!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 父级节点 */
    parentId!: string | undefined;

    constructor(data?: ITransferDirectoryGroupOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allPath = data["allPath"];
            this.id = data["id"];
            this.name = data["name"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): TransferDirectoryGroupOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDirectoryGroupOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allPath"] = this.allPath;
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface ITransferDirectoryGroupOutDto {
    /** 当前节点的all_path */
    allPath: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 父级节点 */
    parentId: string | undefined;
}

export class TransferDirectoryTreeDto implements ITransferDirectoryTreeDto {
    attribute!: any | undefined;
    children!: TransferDirectoryTreeDto[] | undefined;
    data!: TransferDirectoryGroupOutDto | undefined;
    id!: string | undefined;
    key!: string | undefined;
    parentId!: string | undefined;
    title!: string | undefined;
    value!: string | undefined;

    constructor(data?: ITransferDirectoryTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attribute = data["attribute"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(TransferDirectoryTreeDto.fromJS(item));
            }
            this.data = data["data"] ? TransferDirectoryGroupOutDto.fromJS(data["data"]) : <any>undefined;
            this.id = data["id"];
            this.key = data["key"];
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TransferDirectoryTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDirectoryTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITransferDirectoryTreeDto {
    attribute: any | undefined;
    children: TransferDirectoryTreeDto[] | undefined;
    data: TransferDirectoryGroupOutDto | undefined;
    id: string | undefined;
    key: string | undefined;
    parentId: string | undefined;
    title: string | undefined;
    value: string | undefined;
}

export class TransferDirectoryTreeVO implements ITransferDirectoryTreeVO {
    children!: TransferDirectoryTreeVO[] | undefined;
    id!: string | undefined;
    key!: string | undefined;
    parentId!: string | undefined;
    title!: string | undefined;
    transferDirectory!: boolean | undefined;
    value!: string | undefined;

    constructor(data?: ITransferDirectoryTreeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(TransferDirectoryTreeVO.fromJS(item));
            }
            this.id = data["id"];
            this.key = data["key"];
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.transferDirectory = data["transferDirectory"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TransferDirectoryTreeVO {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDirectoryTreeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["transferDirectory"] = this.transferDirectory;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITransferDirectoryTreeVO {
    children: TransferDirectoryTreeVO[] | undefined;
    id: string | undefined;
    key: string | undefined;
    parentId: string | undefined;
    title: string | undefined;
    transferDirectory: boolean | undefined;
    value: string | undefined;
}

export class TransferLogFile implements ITransferLogFile {
    filename!: string | undefined;
    objectKey!: string | undefined;
    originalFilename!: string | undefined;

    constructor(data?: ITransferLogFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filename = data["filename"];
            this.objectKey = data["objectKey"];
            this.originalFilename = data["originalFilename"];
        }
    }

    static fromJS(data: any): TransferLogFile {
        data = typeof data === 'object' ? data : {};
        let result = new TransferLogFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["objectKey"] = this.objectKey;
        data["originalFilename"] = this.originalFilename;
        return data; 
    }
}

export interface ITransferLogFile {
    filename: string | undefined;
    objectKey: string | undefined;
    originalFilename: string | undefined;
}

export class TransferLogVO implements ITransferLogVO {
    fileContent!: TransferLogFile[] | undefined;
    /** 主键Id */
    id!: string | undefined;
    messageType!: number | undefined;
    /** operateId */
    operateId!: string | undefined;
    operateName!: string | undefined;
    operateTime!: Date | undefined;
    operation!: string | undefined;
    /** resourceId */
    resourceId!: string | undefined;
    resourceName!: string | undefined;
    /** transferId */
    transferId!: string | undefined;
    /** versionId */
    versionId!: string | undefined;
    versionName!: string | undefined;

    constructor(data?: ITransferLogVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["fileContent"] && data["fileContent"].constructor === Array) {
                this.fileContent = [] as any;
                for (let item of data["fileContent"])
                    this.fileContent!.push(TransferLogFile.fromJS(item));
            }
            this.id = data["id"];
            this.messageType = data["messageType"];
            this.operateId = data["operateId"];
            this.operateName = data["operateName"];
            this.operateTime = data["operateTime"] ? new Date(data["operateTime"].toString()) : <any>undefined;
            this.operation = data["operation"];
            this.resourceId = data["resourceId"];
            this.resourceName = data["resourceName"];
            this.transferId = data["transferId"];
            this.versionId = data["versionId"];
            this.versionName = data["versionName"];
        }
    }

    static fromJS(data: any): TransferLogVO {
        data = typeof data === 'object' ? data : {};
        let result = new TransferLogVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.fileContent && this.fileContent.constructor === Array) {
            data["fileContent"] = [];
            for (let item of this.fileContent)
                data["fileContent"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["messageType"] = this.messageType;
        data["operateId"] = this.operateId;
        data["operateName"] = this.operateName;
        data["operateTime"] = this.operateTime ? this.operateTime.toISOString() : <any>undefined;
        data["operation"] = this.operation;
        data["resourceId"] = this.resourceId;
        data["resourceName"] = this.resourceName;
        data["transferId"] = this.transferId;
        data["versionId"] = this.versionId;
        data["versionName"] = this.versionName;
        return data; 
    }
}

export interface ITransferLogVO {
    fileContent: TransferLogFile[] | undefined;
    /** 主键Id */
    id: string | undefined;
    messageType: number | undefined;
    /** operateId */
    operateId: string | undefined;
    operateName: string | undefined;
    operateTime: Date | undefined;
    operation: string | undefined;
    /** resourceId */
    resourceId: string | undefined;
    resourceName: string | undefined;
    /** transferId */
    transferId: string | undefined;
    /** versionId */
    versionId: string | undefined;
    versionName: string | undefined;
}

export class UpdateFileDto implements IUpdateFileDto {
    /** 文件id */
    fileId!: string | undefined;
    ossFile!: OssFile | undefined;

    constructor(data?: IUpdateFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.ossFile = data["ossFile"] ? OssFile.fromJS(data["ossFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["ossFile"] = this.ossFile ? this.ossFile.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateFileDto {
    /** 文件id */
    fileId: string | undefined;
    ossFile: OssFile | undefined;
}

export class UploadFileDto implements IUploadFileDto {
    file!: FileDto;
    targetId!: string | undefined;

    constructor(data?: IUploadFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.file = new FileDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.file = data["file"] ? FileDto.fromJS(data["file"]) : new FileDto();
            this.targetId = data["targetId"];
        }
    }

    static fromJS(data: any): UploadFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["targetId"] = this.targetId;
        return data; 
    }
}

export interface IUploadFileDto {
    file: FileDto;
    targetId: string | undefined;
}

export class UploadFileOssDto implements IUploadFileOssDto {
    fileDisplayName!: string | undefined;
    ossFile!: OssFile;
    targetId!: string | undefined;

    constructor(data?: IUploadFileOssDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ossFile = new OssFile();
        }
    }

    init(data?: any) {
        if (data) {
            this.fileDisplayName = data["fileDisplayName"];
            this.ossFile = data["ossFile"] ? OssFile.fromJS(data["ossFile"]) : new OssFile();
            this.targetId = data["targetId"];
        }
    }

    static fromJS(data: any): UploadFileOssDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileOssDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileDisplayName"] = this.fileDisplayName;
        data["ossFile"] = this.ossFile ? this.ossFile.toJSON() : <any>undefined;
        data["targetId"] = this.targetId;
        return data; 
    }
}

export interface IUploadFileOssDto {
    fileDisplayName: string | undefined;
    ossFile: OssFile;
    targetId: string | undefined;
}

export enum FormFieldDtoJsonType {
    NUMBER = "NUMBER", 
    INTEGER = "INTEGER", 
    STRING = "STRING", 
    BOOLEAN = "BOOLEAN", 
    OBJECT = "OBJECT", 
    ARRAY = "ARRAY", 
}

export enum FormFieldDtoWidget {
    INPUT = "INPUT", 
    INPUTNUMBER = "INPUTNUMBER", 
    CHECKBOX = "CHECKBOX", 
    SELECT = "SELECT", 
    DATE = "DATE", 
    RADIO = "RADIO", 
    SWITCH = "SWITCH", 
    UPLOAD = "UPLOAD", 
    TREESELECT = "TREESELECT", 
}

export enum NewFolderDtoFileType {
    FOLDER = "FOLDER", 
    FILE = "FILE", 
    RESOURCE_FILE = "RESOURCE_FILE", 
}

export enum ResourceDetailDtoState {
    DRAFTED = "DRAFTED", 
    PUBLISHED = "PUBLISHED", 
    INITIAL = "INITIAL", 
}

export enum ResourceListDtoState {
    DRAFTED = "DRAFTED", 
    PUBLISHED = "PUBLISHED", 
    INITIAL = "INITIAL", 
}

export enum TableColumnDtoJsonType {
    NUMBER = "NUMBER", 
    INTEGER = "INTEGER", 
    STRING = "STRING", 
    BOOLEAN = "BOOLEAN", 
    OBJECT = "OBJECT", 
    ARRAY = "ARRAY", 
}

export enum TableColumnDtoWidget {
    INPUT = "INPUT", 
    INPUTNUMBER = "INPUTNUMBER", 
    CHECKBOX = "CHECKBOX", 
    SELECT = "SELECT", 
    DATE = "DATE", 
    RADIO = "RADIO", 
    SWITCH = "SWITCH", 
    UPLOAD = "UPLOAD", 
    TREESELECT = "TREESELECT", 
}